import { useState } from "react";
import { cn } from "@/lib/cn";

/*
  Drop the official Pfizer logo as /public/pfizer-logo.svg (or .png) and
  this component will use it automatically. Until then, a text wordmark
  serves as the placeholder so nothing looks broken.
*/

type Props = {
  tone?: "white" | "blue";
  className?: string;
  style?: React.CSSProperties;
};

export function PfizerLogo({ tone = "white", className, style }: Props) {
  const [failed, setFailed] = useState(false);
  const src = tone === "white" ? "/pfizer-logo-white.svg" : "/pfizer-logo.svg";

  if (failed) {
    return <Wordmark className={className} style={style} />;
  }

  return (
    <img
      src={src}
      alt="Pfizer"
      className={cn("block h-8 w-auto", className)}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}

function Wordmark({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <span
      className={cn(
        "inline-block text-[22px] font-bold tracking-tight text-white",
        className,
      )}
      style={{
        letterSpacing: "-0.02em",
        color: "#00a3e0",
        ...style,
      }}
    >
      pfizer
    </span>
  );
}
